import React from 'react';
import GridControls from './GridControls';

interface XAxisGridProps {
  propKey: string;
  property: any;
  axisProps: any;
  enableGrids: (propKey: string, option: string, value: any) => void;
  updateAxisOptions: (axis: string, option: string, value: any, series?: string) => void;
  isMultiSeries?: boolean;
  iconColor?: string;
}

const XAxisGrid: React.FC<XAxisGridProps> = ({
  propKey,
  property,
  axisProps,
  enableGrids,
  updateAxisOptions,
  isMultiSeries = false,
  iconColor,
}) => {
  return (
    <GridControls
      axisType="x"
      propKey={propKey}
      property={property}
      axisProps={axisProps}
      enableGrids={enableGrids}
      updateAxisOptions={updateAxisOptions}
      isMultiSeries={isMultiSeries}
      iconColor={iconColor}
    />
  );
};

export default XAxisGrid;
